import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex-col flex-1 gap-10" }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "flex" }

import { useI18n } from 'vue-i18n';
import { onMounted, ref } from 'vue';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { Button, FloatLabel, Tab, TabList, TabPanel, TabPanels, Tabs, Textarea, useToast } from 'primevue';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { NotificationLanguageIsoCodeEnum, NotificationTemplateApi, NotificationTemplateResponse, UpdateTemplateOperationRequest } from '@/apiGenerate/medserver';


export default /*@__PURE__*/_defineComponent({
  __name: 'esNotification',
  setup(__props) {

const { t } = useI18n();
const toast = useToast();

const templateApi = new NotificationTemplateApi(medServerApiConfig);

const languages = Object.values(NotificationLanguageIsoCodeEnum);
const templates = ref<NotificationTemplateResponse[]>([]);

const findAllTemplates = async () => {
    templateApi.findNotificationTemplates().then((response) => {
        templates.value = response;
    }).catch((error) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
    });
};

const handleUpdateTemplate = async (template: NotificationTemplateResponse) => {
    const updateTemplateRequest: UpdateTemplateOperationRequest = {
        templateId: template.uuid,
        updateTemplateRequest: {
            content: template.content
        }
    };

    templateApi.updateTemplate(updateTemplateRequest).then(async () => {
        toastSuccess(toast, {
            summary: t("common.toast.success.update"),
            detail: t("admin.notifications.message.success.update")
        });
        
        await findAllTemplates();
    }).catch((error) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
    });
};

const selectedTemplates = ((iso: NotificationLanguageIsoCodeEnum) => {
    return templates.value.filter(template => 
       template.language === iso
    );
});

onMounted(async () => {
   await findAllTemplates();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('admin.subMenu.notifications')), 1)
    ]),
    _createVNode(_unref(Tabs), {
      value: _unref(languages)[0],
      class: "w-full"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TabList), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
              return (_openBlock(), _createBlock(_unref(Tab), {
                key: language,
                value: language
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(language), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanels), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
              return (_openBlock(), _createBlock(_unref(TabPanel), {
                key: language + 'test',
                value: language
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplates(language), (template) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "template",
                        key: template.uuid
                      }, [
                        _createVNode(_unref(FloatLabel), { variant: "on" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Textarea), {
                              id: template.label,
                              modelValue: template.content,
                              "onUpdate:modelValue": ($event: any) => ((template.content) = $event),
                              fluid: "",
                              disabled: !template.uuid
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled"]),
                            _createElementVNode("label", {
                              for: template.label
                            }, _toDisplayString(template.label), 9, _hoisted_4)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_5, [
                          (template.uuid)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 0,
                                onClick: ($event: any) => (handleUpdateTemplate(template))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)("action.update")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}
}

})